exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tos-content {\n  width: 100vw;\n  padding: 0 8vw;\n  min-height: 500px;\n  background-color: #fff;\n  margin-bottom: 50px;\n}\n.tos-content h1 {\n  font-family: Nunito;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 24px;\n  line-height: 40px;\n  margin-top: 32px;\n  color: #000;\n  text-align: left;\n}\n.tos-content h3,\n.tos-content h2 {\n  font-family: Nunito;\n  font-style: normal;\n  text-align: left;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 24px;\n  color: #000;\n  margin-top: 30px;\n}\n.tos-content p {\n  margin-top: 20px;\n  font-size: unset;\n}\n.tos-content .underline-txt {\n  text-decoration: underline;\n  display: inline;\n}\n.tos-content ul {\n  padding: 20px 20px;\n  font-size: unset;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/Tos.vue?vue&type=style&index=0&id=33858724&lang=stylus
// module id = 298
// module chunks = 8